import React, { useContext } from "react";
import { ModalWithButton } from "components/modalWithButton/ModalWithButton";
import ContentPage from "components/contentPage/ContentPage";
import { AddStaffFoodModal } from "components/addStaffFoodModal/AddStaffFoodModal";
import { BranchFavouriteContext } from "contexts/BranchFavouriteContext";
import { IBranch } from "types/Branch";
import { StaffFoodTable } from "components/staffFoodTable/StaffFoodTable";
import styles from "./StaffFood.module.css";
import {
  BranchSelector,
  IBranchSelectorProps,
} from "components/branchSelector/BranchSelector";
import {
  MaterialContext,
  IMaterialContextInterface,
} from "contexts/MaterialsContext";
import { useLocalBranch } from "hooks/LocalStorage";
import { AddFavouriteModalHelper } from "components/addFavouriteModalHelper/AddFavouriteModalHelper";
import { AddFavouritesModal } from "components/addFavouritesModal/AddFavouritesModal";
import { FavouriteEntity } from "types/Favourite";
import { getSettings } from "api/GetSettings";
import StaffFoodIcon from "assets/StaffFoodIcon";

const StaffFood: React.FC = React.memo(() => {
  const { branches } = useContext(BranchFavouriteContext);
  const materialContextValues = useContext(MaterialContext);
  const [selectedBranch, setSelectedBranch] = useLocalBranch(
    branches.length > 0 ? branches[0] : undefined
  );

  // // TODO handle no branches error
  if (!selectedBranch || materialContextValues.fetchingStatus !== "completed") {
    return <></>;
  }
  return (
    <ContentPage
      header={
        <Header
          branches={branches!}
          selectedBranch={selectedBranch}
          setSelectedBranch={setSelectedBranch}
        />
      }
      mainContent={<MainSection selectedBranch={selectedBranch} />}
      rightSection={
        <RightSection
          materialContextValues={
            materialContextValues.branchWiseMaterialsMap.get(selectedBranch.id)!
          }
          selectedBranch={selectedBranch}
        />
      }
    />
  );
});

const Header: React.FC<IBranchSelectorProps> = (props) => (
  <>
    <div className={styles.pageName}>{"Staff Food"}</div>
    <BranchSelector {...props} />
  </>
);

const MainSection: React.FC<{ selectedBranch: IBranch }> = (props) => (
  <>
    <StaffFoodTable selectedBranch={props.selectedBranch} />
  </>
);

const RightSection: React.FC<{
  materialContextValues: IMaterialContextInterface;
  selectedBranch: IBranch;
}> = (props) => (
  <>
    <ModalWithButton title={"Add Staff Food"} icon={<StaffFoodIcon />}>
      {" "}
      <AddStaffFoodModal
        materialContextValues={props.materialContextValues}
        selectedBranch={props.selectedBranch}
      />{" "}
    </ModalWithButton>
    <AddFavouriteModalHelper>
      {" "}
      <AddFavouritesModal
        selectedBranch={props.selectedBranch}
        materials={
          props.materialContextValues?.allMaterialsArrForFoodAnalysis ?? []
        }
        favouriteEntity={FavouriteEntity.STAFF_FOOD}
        onClose={getSettings}
      />{" "}
    </AddFavouriteModalHelper>
  </>
);

export default StaffFood;
